import React from 'react';
import { cn } from './cn';

/**
 * EmptyState — for empty lists, filtered-to-nothing, and error placeholders.
 * Keep four distinct messages across the app (no data · filtered · error · loading),
 * not one generic "No data".
 *
 *   <EmptyState
 *     icon={<FiInbox size={24} />}
 *     title="No pending requests"
 *     description="Partners haven't submitted any new clients."
 *     action={<Button>Invite partner</Button>}
 *   />
 */
export function EmptyState({ icon, title, description, action, variant = 'default', className }) {
  return (
    <div
      className={cn(
        'flex flex-col items-center justify-center text-center',
        'py-16 px-6',
        className,
      )}
    >
      {icon && (
        <div
          className={cn(
            'mb-4 inline-flex h-12 w-12 items-center justify-center rounded-full',
            variant === 'danger'
              ? 'bg-danger-50 text-danger-600 ring-8 ring-danger-50/50 dark:bg-danger-500/10 dark:text-danger-500 dark:ring-danger-500/5'
              : 'bg-ink-100 text-fg-muted ring-8 ring-ink-50 dark:bg-ink-700 dark:ring-ink-800',
          )}
        >
          {icon}
        </div>
      )}
      {title && <p className="text-body font-semibold text-fg">{title}</p>}
      {description && (
        <p className="mt-1 max-w-sm text-body-sm text-fg-muted">{description}</p>
      )}
      {action && <div className="mt-5">{action}</div>}
    </div>
  );
}

export default EmptyState;
